import { Fragment } from 'react'

import { LISTING_PROFILE_WIDGET_KEY } from './RentalPortalListingProfileWidgetList.constants'

function getListingProfileWidgetListOrder(widgetListOrder) {
  return [
    LISTING_PROFILE_WIDGET_KEY.attention,
    ...widgetListOrder.filter(
      key => key !== LISTING_PROFILE_WIDGET_KEY.attention
    ),
  ]
}

export function getListingProfileOrderedWidgets({ widgetListOrder, widgets }) {
  return getListingProfileWidgetListOrder(widgetListOrder)
    .filter(widgetKey => widgets[widgetKey])
    .map(widgetKey => <Fragment key={widgetKey}>{widgets[widgetKey]}</Fragment>)
}
